export default {
    language: 'nb-NO',
    navigation: 'Tilbake',
    home: {
        title: 'Malings Kalkulator',
        subtitle:
            'Vi hjelper deg med å finne det riktige bunnstoffsystemet til båten din og beregner det volumet du har behov for',
        findProduct: 'Finn produkt',
        calculateVolume: 'Beregn volum'
    },
    find: {
        questions: {
            type: 'Velg <strong>båttype</strong>?',
            material: 'Velg <strong>Båtmateriale</strong>?',
            sailFrequency: '<strong>Hvor ofte</strong> bruker du båten?',
            paintLocation: '<strong>Hvor</strong> maler du båten?',
            waterType: 'Millaisen <strong>veden käytät</strong> venettäsi?'
        },
        answers: {
            help: 'Vil du ha hjelp med å velge bunnstoff?',

            type: [
                {
                    label: 'Seiling',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motorbåt',
                    sublabel: 'opptil 20 knop',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Strøm (høy hastighet)',
                    sublabel: 'raskere enn 20 knop',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Glassfiber',
                    value: 'plastic'
                },
                {
                    label: 'Jern',
                    value: 'iron'
                },
                {
                    label: 'Tre',
                    value: 'wood'
                },
                {
                    label: 'Aluminium',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Sjeldent',
                    sublabel: '1-2 ganger i måneden eller mindre',
                    value: 'low'
                },
                {
                    label: 'Ofte',
                    sublabel: '1-2 ganger i uken',
                    value: 'medium'
                },
                {
                    label: 'Veldig ofte',
                    sublabel: 'Nesten hver dag',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Choose country',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Canada', value: 'en-CA' },
                        { label: 'Danmark', value: 'da-DK' },
                        { label: 'Spania', value: 'es-ES' },
                        { label: 'Finland', value: 'fi-FI' },
                        { label: 'Tyskland', value: 'de-DE' },
                        { label: 'Hellas', value: 'el-GR' },
                        { label: 'Kroatia', value: 'hr-HR' },
                        { label: 'Norge', value: 'nb-NO' },
                        { label: 'Nederland', value: 'nl-NL' },
                        { label: 'Sverige - østkysten', value: 'sv-SE_e' },
                        { label: 'Sverige - vestkysten', value: 'sv-SE_w' },
                        { label: 'Sverige - innsjø', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Sjø/Hav', value: 'sea/ocean' },
                { label: 'Elv', value: 'rivers' },
                { label: 'Innsjø', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Anbefaler vi',
            selection: {
                title: 'Ditt valg',
                type: 'Båttype',
                waterType: 'Veden tyyppi',
                material: 'Båtmateriale',
                sailFrequency: 'Aktivitet',
                country: 'Land'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Beste kjøp',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Beste kjøp',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Finn ut mer',
            whereToBuy: 'Hvor du kan kjøpe',
            email: 'Epostadresse',
            send: 'Sende',
            feedback: {
                title: 'Var informasjonen nyttig?',
                yes: 'Ja',
                no: 'Nei',
                comment: 'Kommentar',
                placeholder: 'Kommentar'
            },
            recommendation: {
                title: 'Send anbefalingene med e-post'
            },
            calculateVolume: 'Beregn volum'
        }
    },
    calculate: {
        letsCalculate: 'Beregn',
        questions: {
            antifouling: 'Velg Bunnstoffer',
            keelType: '<strong>Kjøl</strong> type?',
            dimensions: 'Båtens <strong>dimensjoner</strong>?'
        },
        answers: {
            keelType: [
                {
                    label: 'Finnekjøl',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Lang kjøl',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individuelle dimensjoner'
                },
                {
                    title: 'ELLER undervannsareal i m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Enhet',
                    values: [{ label: 'Meters', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Vannlinjens lengde'
                },
                {
                    type: 'beam',
                    label: 'Bredde'
                },
                {
                    type: 'draft',
                    label: 'Dybde'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Anbefalt volum',
            selection: {
                title: 'Ditt valg',
                antifouling: 'Bunnstoff',
                type: 'Båttype',
                material: 'Båtmateriale',
                sailFrequency: 'Aktivitet',
                country: 'Land',
                keelType: 'Kjøl type',
                dimensions: 'Båtens dimensjoner'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Beste kjøp',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Beste kjøp',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Foreslått mengde',
            suggestedAmountTwoCoats: 'Foreslått mengde (2 strøk)',
            oneCoat: '(1 strøk)',
            fiveCoats: '(5 strøk)',
            primerAltTiecoatSilic: 'Ikke glem at du alltid må bruke Tiecoat!',
            primerAltSilicSealSilic:
                '<strong>ALTERNATIV 2</strong><br/>Påføring over gammelt bunnstoff som er i god stand - enkel overgang til Silic One-system',
            primerAlLightSilic:
                '<strong>ALTERNATIV 1</strong><br/>Gammelt bunnstoff fjernes, og det komplette systemet påføres & ny båt uten epoksy',

            primerAltTiecoat:
                '<strong>EKSEMPEL 2: Trinn 2</strong><br/>...og deretter ett strøk Conversion primer',
            primerAltSilicSeal:
                '<strong>EKSEMPEL 2: Trinn 1</strong><br/>For båter uten bunnstoff, påfør først et strøk Light Primer...',
            primerAlLight:
                '<strong>EKSEMPEL 1</strong><br/>Påføring på eksisterende bunnstoff i god stand',
            primer:
                'Skroget har store skader eller er det første gang du skal male båten? Du trenger ...',
            whereToBuy: 'Hvor du kan kjøpe',
            email: 'e-post',
            send: 'Sende',
            or: 'eller',
            feedback: {
                title: 'Var informasjonen nyttig?',
                yes: 'Ja',
                no: 'Nei',
                comment: 'Kommentar',
                placeholder: 'Kommentar'
            },
            recommendation: {
                title: 'Send anbefalingene med e-post'
            },
            calculateVolume: 'Beregn volum'
        }
    },
    map: {
        country: 'Land',
        city: 'By',
        getDirections: 'Få veibeskrivelser',
        placeholder: 'Alle byer...'
    },
    footer: 'Hempel Yacht - alt du trenger å vite om båtmaling'
}
